/**
 * Times on People › Access are moments, not days: when a grant ends (the end
 * of the day the admin picked, in their own timezone), when a device was last
 * seen, when the rules were pushed. All of them read in local time.
 */

const MINUTE = 60_000
const HOUR = 60 * MINUTE
const DAY = 24 * HOUR

/** "just now", "4 min ago", "3 h ago", "2 days ago", then the date. */
export function ago(iso: string, now: number = Date.now()): string {
  const d = now - Date.parse(iso)
  if (d < MINUTE) return 'just now'
  if (d < HOUR) return `${Math.floor(d / MINUTE)} min ago`
  if (d < DAY) return `${Math.floor(d / HOUR)} h ago`
  if (d < 14 * DAY) return `${Math.floor(d / DAY)} days ago`
  return new Date(iso).toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' })
}

/** "12 Nov 2026" — the day a grant ends, as the admin picked it. */
export function day(iso: string): string {
  return new Date(iso).toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' })
}

/** "18:04" — when a join key lapses. */
export function clock(iso: string): string {
  return new Date(iso).toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' })
}

/** The end of a picked day (`2026-11-12` from a date input), local time, as an instant. */
export function endOfDay(date: string): string {
  const [y, m, d] = date.split('-').map(Number)
  return new Date(y as number, (m as number) - 1, d as number, 23, 59, 59).toISOString()
}

/** A server refusal arrives as "409: the sentence"; the sentence is what to show. */
export function problemOf(e: Error): string {
  return e.message.replace(/^\d+:\s*/, '')
}
